import { useCallback, useState } from 'react'

export type UseServicesModalReturn = {
	isOpen: boolean
	openModal: () => void
	closeModal: () => void
}

/**
 * Хук для управления модальным окном списка услуг
 * @returns объект с состоянием модалки и функциями управления
 */
export const useServicesModal = (): UseServicesModalReturn => {
	const [isOpen, setIsOpen] = useState(false)

	const openModal = useCallback(() => {
		setIsOpen(true)
	}, [])

	const closeModal = useCallback(() => {
		setIsOpen(false)
	}, [])

	return {
		isOpen,
		openModal,
		closeModal
	}
}
